<template>
  <div>
    <appHeader></appHeader>
    <div class="container-fluid admin-user-manager-add-user">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 col-sm-12 p-4">
            <form v-on:submit.prevent="userManagerAddUser">
              <h4>User Manager</h4>
              <hr />
              <h6>Add User</h6>
              <br />
              <p>*These fields are required</p>
              <div class="row my-3">
                <div class="col-sm-12 col-lg-8 col-md-8">
                  <div class="row my-2">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <p>Username*</p>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input
                        v-model="UserName"
                        name="userName"
                        type="text"
                        value=""
                        autocomplete="off"
                      ></b-form-input>
                      <small>no spaces, must be unique for each user</small>
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <p>Password*</p>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input
                        v-model="Password"
                        :type="fieldTypes.password"
                        name="password"
                        value=""
                        @focus="handleType"
                        @blur="handleType"
                        disabled
                        style="cursor: not-allowed"
                        autocomplete="off"
                      ></b-form-input>
                      <small>(Password is autogenerated by system)</small>
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <p>Starting Points</p>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="StartingPoints"></b-form-input>
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <p>Single Item Only</p>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-radio-group
                        v-model="SingleItem"
                        :options="SingleItemOptions"
                        class="mb-3"
                        value-field="item"
                        text-field="name"
                        disabled-field="notEnabled"
                      ></b-form-radio-group>
                      <small
                        >(Yes = starting points become max point value for this
                        item)</small
                      >
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <p>Code</p>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="Code"></b-form-input>
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <p>Code2</p>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="Code2"></b-form-input>
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <p>Client</p>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-select
                        v-model="SelectClient"
                        :options="SelectClientOptions"
                      ></b-form-select>
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <p>First Name</p>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="FirstName"></b-form-input>
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <p>Middle Name</p>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="MiddleName"></b-form-input>
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <p>Last Name</p>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="LastName"></b-form-input>
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <p>Address ATTN</p>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="AddressAtn"></b-form-input>
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <p>Address</p>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="Address"></b-form-input>
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <p>City</p>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="City"></b-form-input>
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <p>State</p>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="State"></b-form-input>
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <p>Zip Code</p>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="ZipCode"></b-form-input>
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <p>Day Phone</p>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="DayPhone"></b-form-input>
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <p>Evening Phone</p>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="EveningPhone"></b-form-input>
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <p>Email</p>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input type="text" v-model="Email"></b-form-input>
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <p>Social Security No.</p>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="SocialSecurityNo"></b-form-input>
                      <small>(Optional, no dashes. Ex: 123456789)</small>
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <p>Joining Date</p>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="JoiningDate"></b-form-input>
                      <small>(Month/Day/Year) eg: 12/12/2022</small>
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <p>Birthday</p>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="BirthDay"></b-form-input>
                      <small>(Month/Day) eg: 12/12</small>
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <p>Birthyear</p>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="BirthYear"></b-form-input>
                      <small>(Year) eg: 2022</small>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-3">
                <input
                  class="btn btn-primary btn-lg btn-sm-block mr-2"
                  type="submit"
                  name="add"
                  value="Add"
                />
                <router-link
                  :to="{
                    name: 'AdminUserManager',
                  }"
                  @click.native="scrollToTop"
                  class="btn btn-primary btn-lg btn-sm-block mr-2"
                  type="button"
                  >Cancel</router-link
                >
              </div>
            </form>
          </div>
        </transition>
      </div>
    </div>
    <appFooter></appFooter>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import AdminSidebar from "@/views/admin/AdminSidebar.vue";
import { mapState } from "vuex";
import {
  getCustomizedTimestamp,
  validateMonthDateYearFormat,
  validateMonthDay,
  validateYear,
} from "@/utilities/date.js";

export default {
  name: "AdminUserManagerAddUser",

  components: {
    appHeader: Header,
    appFooter: Footer,
    appAdminSidebar: AdminSidebar,
  },

  data() {
    return {
      Email: "",
      UserName: "",
      Password: "password",
      StartingPoints: 0,
      SingleItem: false,
      SingleItemOptions: [
        { item: true, name: "Yes" },
        { item: false, name: "No" },
      ],
      Code: "",
      Code2: "",
      SelectClient: null,
      SelectClientOptions: [],
      FirstName: "",
      MiddleName: "",
      LastName: "",
      AddressAtn: "",
      Address: "",
      City: "",
      State: "",
      ZipCode: "",
      DayPhone: "",
      EveningPhone: "",
      SocialSecurityNo: "",
      JoiningDate: "",
      BirthDay: "",
      BirthYear: "",
      fieldTypes: {
        password: "password",
      },
    };
  },

  computed: {
    authorizedClients() {
      return this.$store.getters["adminPointPrograms/getAuthorizedClients"];
    },
  },

  watch: {
    authorizedClients(authorizedClients) {
      var datas = [];
      authorizedClients.map(function (data) {
        datas.push({
          value: data.clientId,
          text: data.clientName,
        });
      });

      this.SelectClient = datas.length > 0 ? datas[0].value : null;
      this.SelectClientOptions = datas;
    },
  },

  created() {
    this.scrollToTop();
    this.$store.dispatch("adminPointPrograms/fetchAuthorizedClients");
  },

  destroyed() {
    if (this.$route.name === "AdminUserManager") {
    } else {
      this.$store.commit("userManager/SET_FILTER_DATA_FOR_USER_MANAGER", {
        companyId: 0,
        userType: 0,
        status: 2,
        recordsPerScreen: 5,
        search: "",
      });
    }
  },

  methods: {
    userManagerAddUser: function () {
      if (!this.UserName.trim()) {
        alert("Username is required.");
      } else if (!this.Password) {
        alert("Password is required.");
      }

      this.JoiningDate =
        this.JoiningDate && validateMonthDateYearFormat(this.JoiningDate)
          ? this.JoiningDate
          : "";
      this.BirthDay =
        this.BirthDay && validateMonthDay(this.BirthDay) ? this.BirthDay : "";
      this.BirthYear =
        this.BirthYear && validateYear(this.BirthYear) ? this.BirthYear : "";
      if (this.UserName && this.Password) {
        const params = {
          username: this.UserName.trim(),
          password: this.Password,
          code: this.Code,
          code2: this.Code2,
          company: "",
          points: +this.StartingPoints,
          admin: 0 /*todo: added hardcoded values */,
          singleitem: this.SingleItem,
          firstname: this.FirstName,
          middleinitial: this.MiddleName,
          lastname: this.LastName,
          address1: this.AddressAtn,
          address2: this.Address,
          city: this.City,
          state: this.State,
          zip: this.ZipCode,
          dayphone: this.DayPhone,
          eveningphone: this.EveningPhone,
          email: this.Email,
          ssn: this.SocialSecurityNo,
          joiningdate: this.JoiningDate,
          birthday: this.BirthDay,
          birthyear: this.BirthYear,
          client_Id: +this.SelectClient,
        };

        console.log(params);

        this.$store
          .dispatch("userManager/addUserManager", params)
          .then((userId) => {
            console.log("succesfully added the user", userId);
            this.$router.push({
              name: "AdminUserManagerMessage",
              params: { userId: userId, action: "added" },
            });
          })
          .catch(() => {
            console.log("error occured ..");
          });
      }
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    handleType(event) {
      const { srcElement, type } = event;
      const { name, value } = srcElement;

      if (type === "blur" && !value) {
        this.fieldTypes[name] = "text";
      } else {
        this.fieldTypes[name] = "password";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.admin-user-manager-add-user {
  margin: -14px 0 0 0;
  .badge {
    font-size: 0.8rem;
    padding: 6px 0px;
    border-radius: $border-radius-sm;
  }
}
.datetime-style {
  background-color: blue;
}
</style>
